import { render, staticRenderFns } from "./MyAccountMenu.vue?vue&type=template&id=1abd14b3&scoped=true&"
import script from "./MyAccountMenu.vue?vue&type=script&lang=ts&"
export * from "./MyAccountMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccountMenu.vue?vue&type=style&index=0&id=1abd14b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abd14b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
